import React from 'react';
import { useDrag, useDrop } from 'react-dnd';
import useStyles from 'isomorphic-style-loader/useStyles';

import { IconDragThick } from '@sololearnorg/sol';

import { useIsOptionRichText } from '../Common/useIsOptionRichText';
import { SL_REARRANGE_QUESTION } from './constants';

import s from './RearrangeAnswerItem.scss';
import { IAnswerOption } from '../../../../api/private/learn-engine-api/learn-engine-api.interface';

export interface IRearrangeAnswerItemProps {
    option: IAnswerOption;
    moveCard: (droppedId: number, originalIndex: number) => void;
    findCard: (id: number) => {
        card: IAnswerOption;
        index: number;
    };
}
interface DragObject {
    type: string;
    id: number;
    originalIndex: number;
}

export const RearrangeAnswerItem = React.memo(
	({
		option,
		moveCard,
		findCard,
	}: IRearrangeAnswerItemProps): JSX.Element => {
		useStyles(s);
		const { id, text, status } = option;
		const originalIndex = findCard(id).index;
		const isOptionRichText = useIsOptionRichText(text);

		const [{ isDragging }, drag] = useDrag({
			type: SL_REARRANGE_QUESTION,
			item: {
				type: SL_REARRANGE_QUESTION,
				id,
				originalIndex,
				text,
			} as DragObject,
			collect: (monitor) => ({
				isDragging: monitor.isDragging(),
				canDrag: monitor.canDrag(),
			}),
		});

		const [, drop] = useDrop({
			accept: SL_REARRANGE_QUESTION,
			canDrop: () => false,
			hover({ id: draggedId }: DragObject) {
				if (draggedId !== id) {
					const { index: overIndex } = findCard(id);
					moveCard(draggedId, overIndex);
				}
			},
		});

		return (
			<div
				className={`sl-rearrange-answer-item ${status}${
					isDragging ? ' hide' : ''
				}`}
				ref={(node) => {
					drag(drop(node));
				}}
				sl-test-data="cmpRearrangeAnswerItem"
			>
				{isOptionRichText ? (
					<span
						className="sl-rearrange-answer-item__text"
						dangerouslySetInnerHTML={{
							__html: option.text,
						}}
					/>
				) : (
					<span className="sl-rearrange-answer-item__text">
						{option.text}
					</span>
				)}

				<IconDragThick
					size={20}
					className="sl-rearrange-answer__burger"
				/>
			</div>
		);
	},
);
